import abi from './abi'

export const UniswapV3Pool = {
  abi,
} as const
